@if (open) {
  <div class="card-holder" #cardHolder [@showTrigger] (@showTrigger.start)="beforeAnimation()" (@showTrigger.done)="afterAnimation()"  (contextmenu)="dontPropagate($event)">
    @if (hasInfo()) {
      <mat-card appearance="outlined" class="pm-info-card mat-elevation-z10" (click)="onCardClicked()">
        <mat-card-header>
          @if (isInfoExtended && !isInfoEditing) {
            <div mat-card-title>{{node.info}}</div>
          }
          @if (!node.isTemplateTop) {
            <div mat-card-subtitle>{{'menu.link.internal-document' | translate}} @if (isAutoTranslated) {
              <span class="mat-small">{{'menu.link.auto-translated' | translate}}</span>
            }</div>
          }
        </mat-card-header>
        @if (isInfoExtended && !isInfoEditing) {
          <mat-card-content (pmLinkClick)="embeddedInfoLinkClicked($event)"
          [innerHtml]="node.extendedInfo | unsafeHtml"></mat-card-content>
        }
        @if (!isInfoExtended && !isInfoEditing) {
          <mat-card-content>{{node.info}}</mat-card-content>
        }
        @if (isInfoEditing) {
          <mat-card-content>
            <mat-form-field>
              <input matInput type="text" placeholder="{{'menu.link.title' | translate}}" name="pm-title-field"
                [value]="tempInfoTitle" (input)="updateInfoTitle($event)" required>
            </mat-form-field>
            <div class="pm-info-editor" [pmTrumbowyg]="trumbowygOptions" [innerHtml]="extendedInfo | unsafeHtml"
            (textUpdate)="onBodyChange($event)" [autoFocus]="false"></div>
          </mat-card-content>
        }
        @if (isAuthor && node.writeable) {
          <mat-card-actions (click)="stopPropagation($event)" align="end">
            @if (showRemoveButton) {
              <button mat-raised-button class="pm-remove-link" color="warn" (click)="onRemoveInfo($event)">{{buttonRemoveLabel | async}}
              </button>
            }
            @if (!isInfoEditing) {
              <button mat-raised-button class="pm-edit-link" color="primary" (click)="onEditInfo($event)">
                {{buttonEditLabel | async}}
              </button>
            }
            <span class="pull-right"></span>
            <pm-color-picker-input [color]="linkColor" (colorChanged)="colorChanged($event)"></pm-color-picker-input>
          </mat-card-actions>
        }
      </mat-card>
    }
    @for (link of filteredLinks; track getLinkId($index, link)) {
      <pm-embedcard [link]="link" [node]="node" (remove)="onRemoveLink(link)"
      (linkClicked)="onLinkClicked(link)"></pm-embedcard>
    }
  </div>
}
